module.exports = __webpack_public_path__ + "assets/img/12_102_big.7b322c3d.jpg";